var cell_default = {
  "cell": "kK-wA",
  "header": "gY6xX",
  "selected": "dlk8r",
  "editing": "nP6IK",
  "singleSelection": "IpK-E",
  "hideLastBlock": "i0yiY",
  "editorWrapper": "bPSvC",
  "viewerWrapper": "RzBup",
  "hideFirstBlock": "drctM",
  "editor": "s9Ywe",
  "edit": "_6rn0l",
  "view": "O0Yym",
  "editingToolbarWrapper": "qHiJt",
  "selectAll": "Fnv2z",
  "disableSelection": "zLUQU"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
